import { Box, BoxProps } from 'roo-ui/components';
import ExpandableBreakdown from 'components/payments/primitives/ExpandableBreakdown';
import PaymentBreakdown from './PaymentBreakdown';
import * as track from 'lib/gaTracking/changeDatesPageEvents';
import { FC } from 'react';
import { useChangeDates } from 'pages/ChangeDatesPage/ChangeDatesProvider';

const titleStyle = {
  fontSize: 'base',
  color: '#333333',
};

const iconStyle = {
  color: '#333333',
};

const AdditionalPayment: FC<BoxProps> = (props) => {
  const { amendment } = useChangeDates();
  return (
    <Box mb={4} {...props}>
      <ExpandableBreakdown
        data-testid="change-date-quote-additional-payment"
        toggleText="Payment breakdown"
        initiallyOpen
        onToggled={(isOpen: boolean) => track.togglePaymentBreakdown(isOpen)}
        textStyle={titleStyle}
        iconStyle={iconStyle}
        flexDirection="row"
        pb={3}
        data-hj-suppress
      >
        <PaymentBreakdown breakdown={amendment!.amendmentTotal!.breakdown} />
      </ExpandableBreakdown>
    </Box>
  );
};

export default AdditionalPayment;
